import './app.js';
import '../scss/tribu.scss';
import masonryLayout from "./js-modules/masonry";

window.addEventListener("DOMContentLoaded", function () {
    masonryLayout();
});